import { useState, useEffect } from "react";
import { Modal, FormField, Input, Button } from "../ui/index";

const plans   = ["Starter", "Professional", "Premium"];
const cycles  = ["Mensuel", "Trimestriel", "Annuel"];
const statuts = ["Actif", "En attente", "Suspendu"];
const methodes = ["Carte bancaire", "Virement bancaire", "Prélèvement SEPA"];
const selectStyle = "w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm text-slate-700 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500";

export default function EditAbonnementModal({ isOpen, onClose, item, onSave }) {
  const [form, setForm] = useState({ plan: "", statut: "", prix: "", cycle: "", methode: "" });

  useEffect(() => {
    if (item) setForm({
      plan: item.plan, statut: item.statut,
      prix: String(item.prix), cycle: item.cycle, methode: item.methode,
    });
  }, [item]);

  const handleChange = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  const handleSubmit = () => {
    onSave?.({ ...form, prix: Number(form.prix) });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Modifier l'abonnement" subtitle="Mettez à jour les informations de l'abonnement.">
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <FormField label="Plan" required>
            <select value={form.plan} onChange={handleChange("plan")} className={selectStyle}>
              {plans.map(p => <option key={p}>{p}</option>)}
            </select>
          </FormField>
          <FormField label="Statut" required>
            <select value={form.statut} onChange={handleChange("statut")} className={selectStyle}>
              {statuts.map(s => <option key={s}>{s}</option>)}
            </select>
          </FormField>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <FormField label="Prix (€)" required>
            <Input value={form.prix} onChange={handleChange("prix")} type="number" />
          </FormField>
          <FormField label="Cycle de facturation" required>
            <select value={form.cycle} onChange={handleChange("cycle")} className={selectStyle}>
              {cycles.map(c => <option key={c}>{c}</option>)}
            </select>
          </FormField>
        </div>

        <FormField label="Méthode de paiement" required>
          <select value={form.methode} onChange={handleChange("methode")} className={selectStyle}>
            {methodes.map(m => <option key={m}>{m}</option>)}
          </select>
        </FormField>

        <div className="flex justify-end gap-3 pt-2">
          <Button variant="secondary" onClick={onClose}>Annuler</Button>
          <Button onClick={handleSubmit}>Enregistrer</Button>
        </div>
      </div>
    </Modal>
  );
}